<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Exceedance Descriptions"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <div class="w-full flex ">
        <span class="mr-10"><b>Exceedance Descriptions </b></span>      
        <l-csv-import @on-import="onExceedanceDescriptions" />
        <span class="mr-10"><b>Exceeding Methods </b></span>      
        <l-csv-import @on-import="onExceedingMethods" />
      </div>
    </l-container>

    <l-info-box
      class="mb-4"
      :active="exceedanceDescriptions.length > 0"
    >Right click a row to edit, delete or add a new record</l-info-box>
    <hot-table :data="exceedanceDescriptions" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="Attainment ID" data="attainment_id" read-only="true"></hot-column>
      <hot-column title="Exceedancedescription Element" data="exceedancedescription_element_name" read-only="true"></hot-column>
      <hot-column title="Exceedances" data="exceedances" read-only="true"></hot-column>
      <hot-column title="Excedance Type" data="excedance_type_name" read-only="true"></hot-column>
      <hot-column title="Max Value" data="max_value" read-only="true"></hot-column>
      <hot-column title="Adjustment Type" data="adjustment_type_label" read-only="true"></hot-column>
      <hot-column title="Surface Area" data="surface_area" read-only="true"></hot-column>
      <hot-column title="Exposed Population" data="exposed_population" read-only="true"></hot-column>
      <hot-column title="Population Reference Year" data="population_reference_year" read-only="true"></hot-column>
      <hot-column title="Vegetation Area" data="vegetation_area" read-only="true"></hot-column>
      <hot-column title="Area Classification" data="area_classification_label" read-only="true"></hot-column>
      <hot-column title="Exceedance Reason" data="exceedance_reason_label" read-only="true"></hot-column>
      <hot-column title="Other Exceedance Reason" data="other_exceedance_reason" read-only="true"></hot-column>
    </hot-table>

    <l-l-edit
      :showing="edit"
      @save="onSaveExceedanceDescriptions"
      @close="edit = false"
      :attainments="attainments"
      :exceedanceDescriptions="exceedanceDescriptions"
      :exceedancedescriptionelements="exceedancedescriptionelements"
      :exceedancetype="exceedancetype"
      :areaclassifications="areaclassifications"
      :adjustmenttypes="adjustmenttypes"
      :exceedancereason="exceedancereason"
      :exceedingdataAll="exceedingdataAll"
      :selected="selected"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import ExceedanceDescriptionsService from "./exceedanceDescriptions.service"

import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";

import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";

export default {
  name: "exceedancedescriptions",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport
  },
  data() {
    return {
      edit: false,
      loading: false,
      exceedanceDescriptions: [],
      attainments: [],
      exceedancedescriptionelements: [],
      exceedancetype: [],
      areaclassifications: [],
      adjustmenttypes: [],
      exceedancereason: [],
      exceedingdataAll: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      isnew: false,
      selected: {}
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.exceedanceDescriptions = await ExceedanceDescriptionsService.exceedancedescriptions();
      this.attainments = await ExceedanceDescriptionsService.attainments();
      this.exceedancedescriptionelements = await ExceedanceDescriptionsService.exceedancedescription();
      this.exceedancetype = await ExceedanceDescriptionsService.exceedancetype();
      this.areaclassifications = await ExceedanceDescriptionsService.areaclassifications();
      this.adjustmenttypes = await ExceedanceDescriptionsService.adjustmenttypes();
      this.exceedancereason = await ExceedanceDescriptionsService.exceedancereason();
      this.exceedingdataAll = await ExceedanceDescriptionsService.exceedingmethods();
    },
    // async deleteExceedanceDescriptions(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await ExceedanceDescriptionsService.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         activeEditor.autoResize.unObserve = () => {};
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("ExceedanceDescriptions deleted!");
    //   }
    // },
    async saveExceedanceDescriptions(ed) {
      
      const rowsAffected = await ExceedanceDescriptionsService.update(ed.exceedingdesc);
      await ExceedanceDescriptionsService.updateMethod({ data: ed.dataUpdate})
      await ExceedanceDescriptionsService.deleteMethod({ ids: ed.dataDelete.toString()});

      console.log("SAVED TO DB");
      const current = this.exceedanceDescriptions.find(n => n.id == ed.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ed[prop];
          }
        }
      };  
    },
    async importExceedingMethods(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await ExceedanceDescriptionsService.importMethods(formData);
      Notify.success("Assessment Methods imported!");
    },
    async onExceedingMethods(file) {
      await Notify.loadData(
        "Importing Assessment Methods",
        this.importExceedingMethods,
        file
      );
    },
    async importExceedanceDescriptions(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await ExceedanceDescriptionsService.import(formData);
      this.exceedancedescriptions = await ExceedanceDescriptionsService.exceedancedescriptions();
      Notify.success("ExceedanceDescriptions imported!");
    },
    async onExceedanceDescriptions(file) {
      await Notify.loadData(
        "Importing ExceedanceDescriptions",
        this.importExceedanceDescriptions,
        file
      );
    },
    onEditExceedanceDescriptions(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;
      var id = row.id;

      // this.exceedingMethods.forEach(function(part, index) {
      //     this[index].selected = !!this[index].id;
      //     this[index].sel =  this[index].selected;
      //   }, this.exceedingMethods); 
    },
    onNewExceedanceDescriptions(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteExceedanceDescriptions(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              const rowsAffected = await ExceedanceDescriptionsService.delete(
                row.id
              );
              const activeEditor = hot.getActiveEditor();
              activeEditor.autoResize.unObserve = () => {};
              hot.alter("remove_row", clickedRow, 1);
            }
          );
          Notify.success("ExceedanceDescriptions deleted!");
        }
      }, "This will delete all data connected to this Exceedance Descriptions. <br/><br/>Do you want to continue?");
    },

    async onSaveExceedanceDescriptions(exceedancedescriptions) {
      await Notify.loadData(
        "Saving changes to ExceedanceDescriptions ",
        this.saveExceedanceDescriptions,
        exceedancedescriptions
      );
      this.selected = {};
      Notify.loadData(null, this.loadInitialData);
    }
  }
};
</script>



